export const ActionContainerArea = 'action-container';

export enum FieldMetaDataRenderer {
    AutoComplete = 0,
    CheckBox = 1,
    DateTime = 2,
    Dropdown = 3,
    RadioButton = 4,
    Text = 5,
    TextArea = 6,
    TextBox = 7,
}

export enum FieldMetaDataType {
    Boolean = 0,
    DateTime = 1,
    Double = 2,
    Integer = 3,
    String = 4,
    CalculatedDouble = 5,
    CalculatedString = 6,
}
